"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledToggleField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_component_library_1 = require("@esub-engineering/react-component-library");
var isNil_1 = __importDefault(require("lodash/isNil"));
var react_hook_form_1 = require("react-hook-form");
exports.ControlledToggleField = react_1.default.memo(function (_a) {
    var control = _a.control, defaultValue = _a.defaultValue, rest = __rest(_a, ["control", "defaultValue"]);
    var _b = (0, react_hook_form_1.useController)({
        name: rest.name,
        control: control,
    }).field, ref = _b.ref, fieldValue = _b.value, onFieldChange = _b.onChange, inputProps = __rest(_b, ["ref", "value", "onChange"]);
    var getInitialValue = function () {
        var _a, _b;
        var initialValue = false;
        if (!(0, isNil_1.default)(fieldValue)) {
            initialValue = fieldValue;
        }
        else if (!(0, isNil_1.default)(defaultValue)) {
            initialValue = defaultValue;
        }
        else if (!(0, isNil_1.default)((_a = rest.options) === null || _a === void 0 ? void 0 : _a.off.value)) {
            initialValue = (_b = rest.options) === null || _b === void 0 ? void 0 : _b.off.value;
        }
        return initialValue;
    };
    var _c = (0, react_1.useState)(getInitialValue()), value = _c[0], setValue = _c[1];
    var handleChange = function (event) {
        var _a, _b, _c, _d;
        var checked = event.target.checked;
        if (checked) {
            setValue(!(0, isNil_1.default)((_a = rest.options) === null || _a === void 0 ? void 0 : _a.on.value) ? (_b = rest.options) === null || _b === void 0 ? void 0 : _b.on.value : true);
        }
        else {
            setValue(!(0, isNil_1.default)((_c = rest.options) === null || _c === void 0 ? void 0 : _c.off.value) ? (_d = rest.options) === null || _d === void 0 ? void 0 : _d.off.value : false);
        }
    };
    (0, react_1.useEffect)(function () {
        onFieldChange({
            target: {
                value: value,
            },
        });
    }, [onFieldChange, value]);
    return ((0, jsx_runtime_1.jsx)(react_component_library_1.Toggle, __assign({}, rest, inputProps, { value: value, onChange: function (event) { return handleChange(event); } })));
});
